import { creditStore } from 'entities/credit';
import { IoIosInformationCircleOutline } from 'react-icons/io';
import { Tooltip } from 'react-tooltip';
export const Credits = () => {
  const { credits, isInActivePlan } = creditStore((state) => ({
    credits: state.credits,
    isInActivePlan: state.isInactivePlan
  }));

  return (
    <div className="yep_ex-flex yep_ex-items-center">
      <div className="yep_ex-text-sm yep_ex-text-neutral-600 yep_ex-flex yep_ex-items-center yep_ex-justify-center">
        <div className="yep_ex-flex yep_ex-justify-end yep_ex-items-center gap-1">
          {credits?.toFixed(2)}
          {credits === 0 && !isInActivePlan && (
            <>
              <IoIosInformationCircleOutline
                data-tooltip-place="top"
                data-tooltip-position-strategy="fixed"
                data-tooltip-id="do-not-have-credits-top-express"
                data-tooltip-content=" You do not have any credits. Further actions will cost $0.2 per credits."
              />
              <Tooltip
                style={{ zIndex: 10000 }}
                id="do-not-have-credits-top-express"
              />
            </>
          )}
        </div>
        <span className="yep_ex-block yep_ex-ml-1">Credits</span>
      </div>
    </div>
  );
};
